import axios from 'axios';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction, IPayload } from 'react-jhipster';

import { defaultValue, IMaintenance, ISearchForm } from 'app/shared/model/maintenance.model';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { flattenKey } from 'app/shared/util/object-utils';
import * as qs from 'qs';
// 接口
export const ACTION_TYPES = {
  FETCH_MAINTENANCE_LIST: 'maintenance/FETCH_MAINTENANCE_LIST',
  LOAD_MAINTENANCE_LIST: 'maintenance/LOAD_MAINTENANCE_LIST',
  FETCH_MAINTENANCE: 'maintenance/FETCH_MAINTENANCE',
  CREATE_MAINTENANCE: 'maintenance/CREATE_MAINTENANCE',
  UPDATE_MAINTENANCE: 'maintenance/UPDATE_MAINTENANCE',
  DELETE_MAINTENANCE: 'maintenance/DELETE_MAINTENANCE',
  RESET: 'maintenance/RESET'
};
// state类型
export declare type ICrudGetListAction<T> = (
  page?: number,
  size?: number,
  sort?: string,
  searchForm?: ISearchForm
) => IPayload<T> | ((dispatch: any) => IPayload<T>);

export type HouseState = Readonly<typeof initialState>;
// state定义
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMaintenance>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0
};

export type MaintenanceState = Readonly<typeof initialState>;

// Reducer

export default (state: MaintenanceState = initialState, action): MaintenanceState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MAINTENANCE_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case REQUEST(ACTION_TYPES.LOAD_MAINTENANCE_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loadMore: true
      };
    case REQUEST(ACTION_TYPES.FETCH_MAINTENANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_MAINTENANCE):
    case REQUEST(ACTION_TYPES.UPDATE_MAINTENANCE):
    case REQUEST(ACTION_TYPES.DELETE_MAINTENANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_MAINTENANCE_LIST):
    case FAILURE(ACTION_TYPES.LOAD_MAINTENANCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MAINTENANCE):
    case FAILURE(ACTION_TYPES.CREATE_MAINTENANCE):
    case FAILURE(ACTION_TYPES.UPDATE_MAINTENANCE):
    case FAILURE(ACTION_TYPES.DELETE_MAINTENANCE):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAINTENANCE_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.LOAD_MAINTENANCE_LIST):
      return {
        ...state,
        loadMore: false,
        entities: state.entities.concat(action.payload.data),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAINTENANCE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_MAINTENANCE):
    case SUCCESS(ACTION_TYPES.UPDATE_MAINTENANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_MAINTENANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/maintenances'; // 保修管理

// Actions
// 保修管理
export const getEntities: ICrudGetListAction<IMaintenance> = (page, size, sort, searhForm) => ({
  type: ACTION_TYPES.FETCH_MAINTENANCE_LIST,
  payload: axios.get<IMaintenance>(`${apiUrl}?cacheBuster=${new Date().getTime()}`, {
    params: flattenKey({ page, size, sort, ...searhForm }),
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
  })
});

export const loadEntities: ICrudGetListAction<IMaintenance> = (page, size, sort, searhForm) => ({
  type: ACTION_TYPES.LOAD_MAINTENANCE_LIST,
  payload: axios.get<IMaintenance>(`${apiUrl}?cacheBuster=${new Date().getTime()}`, {
    params: flattenKey(searhForm),
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
  })
});

export const getEntity: ICrudGetAction<IMaintenance> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MAINTENANCE,
    payload: axios.get<IMaintenance>(requestUrl)
  };
};
// 创建保修管理
export const createEntity: ICrudPutAction<IMaintenance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MAINTENANCE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 更新保修管理
export const updateEntity: ICrudPutAction<IMaintenance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MAINTENANCE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 删除保修管理
export const deleteEntity: ICrudDeleteAction<IMaintenance> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MAINTENANCE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
